import { Middleware } from 'redux'
import { setPersistedState } from '../../persistState'

// Action prefixes that should not trigger state persistence (UI interactions)
const SKIP_PERSISTENCE_PREFIXES = [
    // UI action prefixes
    'CMD / InfoModal',
    'CMD / Notification',
    'CMD / sidebar',
    'CMD / renderImages',
    'CMD / ItemFilter',
    'CMD / BackgroundImageType',
    'CMD / CarlineSelection / toggle',
    
    // All DOC actions (state updates)
    'DOC /',
    
    // Mouse interaction-related actions that affect hover states
    'HOVER_',
    'CLICK_',
]

const persistingMiddleware: Middleware = (store) => (next) => (action) => {
    const result = next(action)
    
    const shouldSkipPersistence = SKIP_PERSISTENCE_PREFIXES.some(prefix => 
        action.type.includes(prefix),
    )
    
    if (!shouldSkipPersistence) {
        setTimeout(() => {
            const { getState } = store
            const state = getState()
            
            setPersistedState(state)
        }, 0)
    }
    
    return result
}

export default persistingMiddleware
